/** Къде стои модулът: цял екран или съдържанието до страничното меню
 *  („Конфигурация", „Резервации"). */
export type PagePlacement = "screen" | "content";

export function placementClassName(placement: PagePlacement): string {
  return placement === "screen"
    ? "flex h-screen items-center justify-center"
    : "flex h-full min-h-[50vh] w-full items-center justify-center";
}
